import { atom } from 'jotai';
import { $CurrentGallerySlide } from '~/components/article-gallery/atoms/swiper';
import { $IsMobileUser } from '~/utils/is-mobile-user';

const $LabelVisibleValue = atom(true);

export const $LabelVisible = atom(
  (get) => {
    const currentGallerySlide = get($CurrentGallerySlide);

    // interception
    const isMobileUser = get($IsMobileUser);
    if (isMobileUser && currentGallerySlide === 1) {
      return false;
    }

    return get($LabelVisibleValue);
  },
  (get, set, input: boolean) => {
    set($LabelVisibleValue, input);
  },
);
